import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { SharedActions } from "./shared-action-types";
import { ProducerActions } from "src/app/producers/state/producer.action.types";

@Injectable({
  providedIn: 'root',
})
export class SharedDispatcher {

  constructor(private store: Store) {
  }

  loadExchangeTypes() {
    this.store.dispatch(SharedActions.loadExchangeTypeReference());
  }

  loadCurrencyOrder() {
    this.store.dispatch(SharedActions.loadOrderCurrencyReference());
  }

  loadCurrencyCreateOrder() {
    this.store.dispatch(SharedActions.loadOrderCreateCurrencyReference());
  }

  loadOrderTransactionTypes() {
    this.store.dispatch(SharedActions.loadOrderTransactionTypesReference());
  }

  forceLoadCurrencyCreateOrder() {
    this.store.dispatch(SharedActions.forceLoadOrderCreateCurrencyReference());
  }

  loadRoleType() {
    this.store.dispatch(SharedActions.loadRoleTypeReference());
  }

  loadTransactionype() {
    this.store.dispatch(SharedActions.loadTransactionTypeReference());
  }

  reloadTransactionype() {
    this.store.dispatch(SharedActions.reloadTransactionTypeReference());
  }

  loadAccountCurrencies() {
    this.store.dispatch(SharedActions.loadAccountCurrenciesReference());
  }

  reloadAccountCurrencies() {
    this.store.dispatch(SharedActions.reloadAccountCurrenciesReference());
  }

  loadCompanyAccountCurrencies() {
    this.store.dispatch(SharedActions.loadCompanyAccountCurrenciesReference());
  }

  reloadCompanyAccountCurrencies() {
    this.store.dispatch(SharedActions.reloadCompanyAccountCurrenciesReference());
  }

  loadExpensesCurrencies() {
    this.store.dispatch(SharedActions.loadExpensesCurrenciesReference());
  }

  loadCustomerRole() {
    this.store.dispatch(SharedActions.loadCustomerRolesReference());
  }

  loadProducerRole() {
    this.store.dispatch(SharedActions.loadProducerRolesReference());
  }

  loadWorkTrays() {
    this.store.dispatch(SharedActions.loadworkTrayReference());
  }

  refreshExchanges() {
    this.store.dispatch(SharedActions.loadAllExchanges());
  }

  searchAllUsers() {
    this.store.dispatch(SharedActions.searchUsers());
  }

  resetWorkTrayReference() {
    this.store.dispatch(SharedActions.resetWorkTrayReference());
  }

  searchFilteredUsers(filters?: string) {
    this.store.dispatch(SharedActions.addFilterUsers({ filters }));
    this.store.dispatch(SharedActions.searchUsers());
  }

  startHelpTour(component: string) {
    this.store.dispatch(SharedActions.startHelpTour({ component }));
  }

  finishHelpTour() {
    this.store.dispatch(SharedActions.finishHelpTour());
  }

  setworkInProgressFlag(workInProgress: boolean) {
    this.store.dispatch(SharedActions.setworkInProgressFlag({ workInProgress }));
  }

  loadNotifications() {
    this.store.dispatch(SharedActions.loadNotifications());
  }

  deleteNotification(id: string) {
    this.store.dispatch(SharedActions.deleteNotification({ id }));
  }

  // References
  loadCompanyVirtualAccounts() {
    this.store.dispatch(SharedActions.loadCompanyVirtualAccount());
  }

  forceReloadCompanyVirtualAccounts() {
    this.store.dispatch(SharedActions.reloadCompanyVirtualAccount());
  }

  loadOffices() {
    this.store.dispatch(SharedActions.loadCompanyOffices());
  }

  loadProductTypes() {
    this.store.dispatch(SharedActions.loadProductTypes());
  }

  // Customers
  loadCustomers() {
    this.store.dispatch(SharedActions.loadCustomers());
  }

  // Suppliers
  loadSuppliers() {
    this.store.dispatch(SharedActions.loadSuppliers());
  }

  loadCompanySettings() {
    this.store.dispatch(SharedActions.loadCompanySettings());
  }

  forceLoadCompanySettings() {
    this.store.dispatch(SharedActions.clearCompanySettings());
    this.store.dispatch(SharedActions.loadCompanySettings());
  }

  forceLoadCustomers() {
    this.store.dispatch(SharedActions.forceLoadCustomers());
  }

  forceLoadProducers() {
    this.store.dispatch(SharedActions.forceLoadProducers());
  }

  clearCompanySettings() {
    this.store.dispatch(SharedActions.clearCompanySettings());
  }

  // Expenses
  loadReasons() {
    this.store.dispatch(SharedActions.loadReasons());
  }

  // Producers
  loadProducers() {
    this.store.dispatch(ProducerActions.loadProducers());
  }
 
  loadProducerList() {
    this.store.dispatch(SharedActions.loadProducerList());
  }
  
  forceLoadProducerList() {
    this.store.dispatch(SharedActions.forceReloadproducerList());
  }
}
